// Date operative nel fuso del club (Europe/Rome), indipendenti dal fuso del dispositivo.
const TZ = "Europe/Rome";
const ymd = new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" });
const dt = new Intl.DateTimeFormat("it-IT", { timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const romeDate = (d = new Date()) => ymd.format(d);
// Sottrae giorni di calendario (non 24h fisse): corretto anche nei cambi di ora legale/solare.
export const romeDaysAgo = (n) => {
  const [y, m, d] = romeDate().split("-").map(Number);
  const u = new Date(Date.UTC(y, m - 1, d - n));
  return `${u.getUTCFullYear()}-${String(u.getUTCMonth() + 1).padStart(2, "0")}-${String(u.getUTCDate()).padStart(2, "0")}`;
};
// Timestamp tecnici (UTC ISO) mostrati in ora italiana.
export const fmtRomeDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  return isNaN(d) ? "—" : dt.format(d);
};
